import { type ShareAccessLevel } from '@store/api/folderEndpoints';

export const SHARE_LEVEL_OPTIONS: { value: ShareAccessLevel; labelKey: string; descriptionKey: string }[] = [
  { value: 'VIEW', labelKey: 'Share_Level_View', descriptionKey: 'Share_Level_View_Desc' },
  { value: 'INSPECT', labelKey: 'Share_Level_Inspect', descriptionKey: 'Share_Level_Inspect_Desc' },
  { value: 'FULL', labelKey: 'Share_Level_Full', descriptionKey: 'Share_Level_Full_Desc' },
];
